import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ToastErrorIcon, ToastSuccessIcon } from "../images";
import { ReactNode } from "react";

type Props = {
  type: "error" | "success";
  title: string;
  text: ReactNode;
  path?: string;
};

const iconMapper = {
  success: { icon: <ToastSuccessIcon />, bgcolor: "#FAFAFA" },
  error: { icon: <ToastErrorIcon />, bgcolor: "#FAFAFA" },
};

export const CustomToast = ({ type, title, text, path }: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      bgcolor={iconMapper[type].bgcolor}
      gap="16px"
      width="100%"
    >
      {iconMapper[type].icon}
      <Stack gap="4px" alignItems="flex-start" sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 500 }}
          color="custom.textDarkBlue"
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="custom.textDarkBlue"
          component="div"
          sx={{ alignSelf: "stretch", width: "100%" }}
        >
          {text}
        </Typography>
        {path && (
          <Link to={path} style={{ textDecoration: "none" }}>
            <Typography variant="body1" color="#1C3C6C" fontWeight={500}>
              Open product
            </Typography>
          </Link>
        )}
      </Stack>
    </Stack>
  );
};
